import React from "react";
import IntakeEngine from "@/intake/IntakeEngine";

// Minimal page wrapper. Not wrapped in SiteLayout so the intake is a
// focused flow — matches checkout/estimate conventions elsewhere.
export default function BrandIntakePage() {
  return <IntakeEngine />;
}
